module.exports = __webpack_public_path__ + "static/media/apartment3.5572e4c3.jpg";